/* =============================================================================
   PROA · O VIGIA DO STOCK nos botões de comprar (03/10/2026)
   Ordem do Silva: «o erro de adicionar produto no carrinho, isso não pode acontecer».

   O que acontecia (medido pelo olho, 7 dias): ~180 tentativas de pôr no carrinho falharam com 422.
     · na página inicial, as montras vêm do motor, que lê o stock de 6 em 6 horas: um produto
       que esgotou entretanto continuava com «Adicionar»;
     · nas coleções, a página fica aberta e o produto esgota entretanto;
     · quantidades acima do que há («Foi adicionado apenas 1», «A quantidade máxima já está no
       seu carrinho»).

   O que este vigia faz:
     1. Os botões de comprar que entram no ecrã perguntam à loja, sem pressa, se o produto ainda
        existe (`/products/<handle>?view=proa-disponivel`, um JSON pequeno). Esgotado: o botão
        passa a «Esgotado», desligado, ANTES de a cliente tocar.
     2. No toque, se o que se sabe tem mais de um minuto (ou não se sabe), pergunta-se outra vez
        antes de deixar seguir. Esgotado: o botão muda e o carrinho nem é chamado.
     3. Com o stock conhecido, a quantidade não passa do que falta pôr no carrinho; com tudo já
        lá dentro, o botão diz «Já no carrinho» (e volta ao normal quando o carrinho muda).
     4. No carrinho, uma quantidade escrita à mão acima do stock corta-se ao máximo, e o «+» aparece
        desligado quando já está no máximo.
     Cada travão avisa o olho (`proa:vigia`), que o conta como erro EVITADO.

   ⛔ NÃO SABER NUNCA IMPEDE UMA COMPRA: qualquer erro, demora (2,5 s) ou resposta estranha deixa
      seguir como se o vigia não existisse. O pior que pode acontecer é o que já acontecia.
   ⛔ O formulário do tema ouve o `submit` no próprio form; aqui ouve-se no `document` na fase de
      CAPTURA, que corre primeiro. Para deixar seguir, volta-se a submeter com a marca `__proaPassa`.
   ⛔ Nada de HTML por texto: só textContent e atributos.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__proaDisponivel) return;
  window.__proaDisponivel = true;
  if (!window.fetch || !document.addEventListener) return;

  var FRESCO_MS = 60000;
  var PRAZO_MS = 2500;
  var MAX_EM_CURSO = 4;
  var SELETOR = 'form[action*="/cart/add"]';
  var cache = {};      // handle → { quando, d: { v: { "<id>": [disponivel, q|null] } } | null }
  var emCurso = {};    // handle → Promise
  var fila = [];
  var aCorrer = 0;
  var carrinho = null; // { quando, porVariante: { "<id>": quantidade } }

  function agora() { return Date.now(); }

  function handleDe(form) {
    var h = form.getAttribute('data-proa-h');
    if (h) return h;
    var cartao = form.closest('[data-proa-h]');
    if (cartao) return cartao.getAttribute('data-proa-h');
    // os cartões do tema: a ligação do produto mora no mesmo cartão
    var caixa = form.closest('.product-card, .card-product, .product-item, li, article');
    var a = caixa && caixa.querySelector('a[href*="/products/"]');
    var m = a && String(a.getAttribute('href')).match(/\/products\/([^/?#]+)/);
    if (m) return decodeURIComponent(m[1]);
    // na ficha do produto, o próprio endereço
    m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function varianteDe(form) {
    var c = form.querySelector('[name="id"]');
    return c && c.value ? String(c.value) : null;
  }

  function quantidadeDe(form) {
    var c = form.querySelector('[name="quantity"]');
    var n = c ? parseInt(c.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function botaoDe(form) {
    return form.querySelector('[type="submit"], [name="add"]');
  }

  // ------------------------------------------------------------- perguntar à loja
  function pedir(h) {
    return new Promise(function (resolver) {
      var ctl = window.AbortController ? new AbortController() : null;
      var t = setTimeout(function () { if (ctl) ctl.abort(); resolver(null); }, PRAZO_MS);
      fetch('/products/' + encodeURIComponent(h) + '?view=proa-disponivel', { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (txt) {
          clearTimeout(t);
          var d = null;
          try { d = txt ? JSON.parse(txt) : null; } catch (e) { d = null; }
          resolver(d && d.v && typeof d.v === 'object' ? d : null);
        })
        .catch(function () { clearTimeout(t); resolver(null); });
    });
  }

  function andarFila() {
    while (aCorrer < MAX_EM_CURSO && fila.length) {
      var tarefa = fila.shift();
      aCorrer++;
      pedir(tarefa.h).then(function (h, fim) {
        return function (d) { aCorrer--; fim(d); andarFila(); };
      }(tarefa.h, tarefa.fim));
    }
  }

  function ler(h, forcar) {
    var c = cache[h];
    if (!forcar && c && agora() - c.quando < FRESCO_MS) return Promise.resolve(c.d);
    if (emCurso[h]) return emCurso[h];
    emCurso[h] = new Promise(function (resolver) {
      fila.push({ h: h, fim: function (d) {
        // uma resposta falhada não se guarda: da próxima vez pergunta-se outra vez
        if (d) cache[h] = { quando: agora(), d: d };
        delete emCurso[h];
        resolver(d);
      } });
      andarFila();
    });
    return emCurso[h];
  }

  function estado(d, v) {
    if (!d || !d.v || !Object.prototype.hasOwnProperty.call(d.v, v)) return null; // não se sabe
    var e = d.v[v];
    if (!e || typeof e[0] !== 'boolean') return null;
    return { disponivel: e[0], q: typeof e[1] === 'number' ? e[1] : null };
  }

  // ------------------------------------------------------------- o carrinho
  function lerCarrinho() {
    if (carrinho && agora() - carrinho.quando < 10000) return Promise.resolve(carrinho);
    return new Promise(function (resolver) {
      var t = setTimeout(function () { resolver(null); }, PRAZO_MS);
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          clearTimeout(t);
          if (!c || !c.items) return resolver(null);
          var por = {};
          for (var i = 0; i < c.items.length; i++) {
            var id = String(c.items[i].variant_id || c.items[i].id);
            por[id] = (por[id] || 0) + (c.items[i].quantity || 0);
          }
          carrinho = { quando: agora(), porVariante: por };
          resolver(carrinho);
        })
        .catch(function () { clearTimeout(t); resolver(null); });
    });
  }
  // o carrinho mudou: o que se sabia dele já não vale
  function carrinhoMudou() {
    carrinho = null;
    if (typeof acertarDepois === 'function') acertarDepois();
    // «Já no carrinho» pode ter deixado de ser verdade: o botão volta, e o próximo toque decide
    var fechados = document.querySelectorAll(SELETOR + '[data-proa-disponivel="carrinho"]');
    for (var i = 0; i < fechados.length; i++) reabrir(fechados[i]);
  }
  ['product-ajax:added', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, carrinhoMudou);
  });
  try {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, carrinhoMudou);
    }
  } catch (e) {}

  // ------------------------------------------------------------- mudar o botão
  // Escreve no TEXTO do botão, não no ícone: o cartão do tema tem primeiro um <span> com o desenho do
  // carrinho (só no telemóvel) e só depois o <span> do texto. Os spans com desenho escondem-se.
  // ⭐ Guarda-se o que se muda (texto, ícones escondidos, rótulo, desligado) para o botão poder
  // VOLTAR ao que era: «Já no carrinho» deixa de ser verdade quando a cliente tira o artigo.
  function escrever(botao, texto) {
    var spans = botao.querySelectorAll('span');
    var alvo = null;
    var antes = { texto: null, alvo: null, escondidos: [], rotulo: botao.getAttribute('aria-label'), desligado: botao.disabled };
    for (var i = 0; i < spans.length; i++) {
      var sp = spans[i];
      if (sp.classList.contains('visually-hidden') || sp.classList.contains('sr-only')) continue;
      if (sp.querySelector('svg, img')) { antes.escondidos.push([sp, sp.style.display]); sp.style.display = 'none'; continue; }
      if (!alvo && sp.textContent.trim()) alvo = sp;
    }
    if (!botao.__proaAntes) botao.__proaAntes = antes;
    // ⛔ guarda-se o HTML, não o texto: o botão da ficha tem lá dentro o `#itpCta` (o preço) e o
    // `add-short`/`add-long`, e repor texto plano achatava-os (auditoria de 04/10).
    if (alvo) { if (botao.__proaAntes.alvo === null) { botao.__proaAntes.alvo = alvo; botao.__proaAntes.texto = alvo.innerHTML; } alvo.textContent = texto; }
    else { if (botao.__proaAntes.texto === null) botao.__proaAntes.texto = botao.innerHTML; botao.textContent = texto; }
  }

  // motivo: 'nao' (esgotado) ou 'carrinho' (todas as unidades já no carrinho)
  function fechar(form, texto, rotulo, motivo, doToque) {
    var b = botaoDe(form);
    form.setAttribute('data-proa-disponivel', motivo || 'nao');
    // ⛔ a marca é da VARIANTE, não do formulário (auditoria de 04/10): na ficha, o mesmo
    // formulário serve todos os tons. Fechado por um tom esgotado, ficava fechado para os outros.
    form.setAttribute('data-proa-disponivel-v', varianteDe(form) || '');
    if (doToque) {
      // o olho (proa-olho.js) conta-o como «vigia», o erro evitado, e não como «sem resposta»
      try { document.dispatchEvent(new CustomEvent('proa:vigia', { detail: { motivo: motivo === 'carrinho' ? 'carrinho' : 'esgotado' } })); } catch (e) {}
    }
    if (!b) return;
    b.disabled = true;
    b.setAttribute('aria-disabled', 'true');
    b.classList.add('proa-esgotado');
    b.setAttribute('aria-label', rotulo);
    escrever(b, texto);
  }

  function reabrir(form) {
    var b = botaoDe(form);
    form.removeAttribute('data-proa-disponivel');
    form.removeAttribute('data-proa-disponivel-v');
    if (!b || !b.__proaAntes) return;
    var a = b.__proaAntes;
    b.__proaAntes = null;
    // ⚠️ ligado SEMPRE: o «desligado» guardado era o do tema a meio de um pedido (auditoria de 03/10),
    // e repô-lo deixava o botão preso. Só se fecham botões que o tema deixou vivos.
    b.disabled = false;
    b.removeAttribute('disabled');
    b.removeAttribute('aria-disabled');
    b.classList.remove('proa-esgotado');
    if (a.rotulo === null) b.removeAttribute('aria-label'); else b.setAttribute('aria-label', a.rotulo);
    if (a.alvo) a.alvo.innerHTML = a.texto; else if (a.texto !== null) b.innerHTML = a.texto;
    for (var i = 0; i < a.escondidos.length; i++) a.escondidos[i][0].style.display = a.escondidos[i][1];
  }

  function aplicar(form, d) {
    var v = varianteDe(form);
    var e = v ? estado(d, v) : null;
    if (!e) return;
    if (!e.disponivel) fechar(form, 'Esgotado', 'Esgotado, sem stock de momento', 'nao', false);
    else if (form.getAttribute('data-proa-disponivel') === 'nao') reabrir(form);
  }

  // ------------------------------------------------------------- 1. os que entram no ecrã
  function vigiar(form) {
    if (form.__proaVisto) return;
    form.__proaVisto = true;
    if (!('IntersectionObserver' in window)) return;
    observador.observe(form);
  }
  var observador = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      observador.unobserve(en.target);
      var f = en.target;
      var b = botaoDe(f);
      if (b && b.disabled) return;   // o tema já o desligou: não se gasta um pedido a confirmar
      var h = handleDe(f);
      if (!h || !varianteDe(f)) return;
      ler(h).then(function (d) { aplicar(f, d); });
    });
  }, { rootMargin: '200px 0px' }) : null;

  function procurar(raiz) {
    var forms = (raiz || document).querySelectorAll(SELETOR);
    for (var i = 0; i < forms.length; i++) vigiar(forms[i]);
  }

  // ⭐ Reparo de 04/10: a ficha troca a variante no mesmo formulário (`#itpVar`). Fechado por um tom
  // esgotado, o botão tem de VOLTAR mal a cliente escolha outro, sem ela ter de tocar às cegas.
  document.addEventListener('change', function (ev) {
    var c = ev.target;
    if (!c || !c.matches || !c.matches('[name="id"]')) return;
    var f = c.closest(SELETOR);
    if (!f || !f.getAttribute('data-proa-disponivel')) return;
    if (f.getAttribute('data-proa-disponivel-v') === String(varianteDe(f) || '')) return;
    reabrir(f);
    var h = handleDe(f);
    if (h) ler(h).then(function (d) { aplicar(f, d); });
  }, true);

  // ------------------------------------------------------------- 2. no toque
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.matches || !f.matches(SELETOR)) return;
    if (f.__proaPassa) { f.__proaPassa = false; return; }
    var h = handleDe(f);
    var v = varianteDe(f);
    var jaFechado = f.getAttribute('data-proa-disponivel');
    if (jaFechado === 'nao' || jaFechado === 'carrinho') {
      // só trava o tom que fechou: trocar de tom (ou de produto) abre o botão outra vez
      if (f.getAttribute('data-proa-disponivel-v') === String(v || '')) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
      reabrir(f);
    }
    if (!h || !v) return; // não se sabe o que é: segue como sempre
    var submetedor = ev.submitter || botaoDe(f);
    // ⛔ dois toques enquanto se espera pela loja davam duas unidades (auditoria de 04/10)
    var bJa = botaoDe(f);
    if (bJa && bJa.getAttribute('aria-busy') === 'true') { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
    ev.preventDefault();
    ev.stopImmediatePropagation();
    var b = botaoDe(f);
    if (b) b.setAttribute('aria-busy', 'true');

    var deixar = function () {
      // ⛔ 04/10/2026 · FORA do despacho deste `submit`. Com a leitura em cache, tudo isto corria em
      // microtarefas, ainda dentro do evento original: o browser ignora `requestSubmit`/`click` nesse
      // momento, e o toque não fazia NADA (medido: 1, 0, 1, 0 pedidos em quatro toques).
      setTimeout(function () {
        if (b) b.removeAttribute('aria-busy');
        f.__proaPassa = true;
        // ⚠️ `f.submit()` NÃO dispara o evento `submit`: no Safari 15 (sem `requestSubmit`) o tema
        // não corria e a compra passava a página inteira. O clique no botão dispara-o em todo o lado.
        try {
          if (f.requestSubmit) f.requestSubmit(submetedor && submetedor.form === f ? submetedor : undefined);
          else if (submetedor && submetedor.form === f && submetedor.click) submetedor.click();
          else f.submit();
        } catch (e) { f.submit(); }
        // o `submit` é síncrono: a marca não pode ficar presa para o toque seguinte
        f.__proaPassa = false;
      }, 0);
    };

    // ⚠️ `ler(h)` respeita o minuto de validade: forçar SEMPRE um pedido novo punha 326 ms entre o
    // toque e o carrinho numa 4G (medido a 04/10). Com leitura fresca, o toque segue logo.
    ler(h).then(function (d) {
      // ⛔ 04/10 · a cliente pode ter trocado de tom enquanto a loja respondia: a resposta é do tom
      // ANTIGO e não pode fechar o botão do novo. Devolve-se o botão e o observador decide.
      if (varianteDe(f) !== v) { if (b) b.removeAttribute('aria-busy'); return ler(h).then(function (d2) { aplicar(f, d2); }); }
      var e = estado(d, v);
      if (!e) return deixar();
      if (!e.disponivel) { if (b) b.removeAttribute('aria-busy'); return fechar(f, 'Esgotado', 'Esgotado, sem stock de momento', 'nao', true); }
      if (e.q === null) return deixar();
      return lerCarrinho().then(function (c) {
        if (varianteDe(f) !== v) { if (b) b.removeAttribute('aria-busy'); return ler(h).then(function (d2) { aplicar(f, d2); }); }
        if (!c) return deixar();
        var falta = e.q - (c.porVariante[v] || 0);
        if (falta <= 0) { if (b) b.removeAttribute('aria-busy'); return fechar(f, 'Já no carrinho', 'Já no carrinho: todas as unidades disponíveis já lá estão', 'carrinho', true); }
        var pede = quantidadeDe(f);
        if (pede > falta) {
          var campo = f.querySelector('[name="quantity"]');
          if (campo) campo.value = String(falta);
        }
        deixar();
      });
    }).catch(deixar);
  }, true);

  // ------------------------------------------------------------- 3-B. a porta para quem compra por JS
  // ⛔ 04/10 · Nem todos os botões de comprar são um `submit`. A barra fixa da ficha, os packs e o
  // «escolhe e leva» chamam o carrinho por JavaScript e passavam ao lado do vigia: a barra fixa dava
  // 422 «Foi adicionado apenas 1 item» (auditoria de 04/10). Quem compra assim pergunta aqui antes.
  // Devolve sempre uma promessa; `{ ok: true }` em tudo o que não se sabe.
  window.proaPodeComprar = function (handle, varianteId, quantidade) {
    var v = String(varianteId || '');
    var q = parseInt(quantidade, 10) > 0 ? parseInt(quantidade, 10) : 1;
    if (!handle || !v) return Promise.resolve({ ok: true });
    return ler(handle).then(function (d) {
      var e = estado(d, v);
      if (!e) return { ok: true };
      if (!e.disponivel) return { ok: false, motivo: 'esgotado', texto: 'Este produto já está esgotado.' };
      if (e.q === null) return { ok: true };
      return lerCarrinho().then(function (c) {
        if (!c) return { ok: true };
        var falta = e.q - (c.porVariante[v] || 0);
        if (falta <= 0) return { ok: false, motivo: 'carrinho', falta: 0, texto: 'Todas as unidades disponíveis já estão no carrinho.' };
        if (q > falta) {
          // ⛔ 04/10 (auditoria A): «só restam N em stock» contradizia a linha de escassez da
          // ficha, que conta o stock INTEIRO. Diz-se o que ainda se pode juntar, e porquê.
          var jaLa = c.porVariante[v] || 0;
          var un = falta === 1 ? '1 unidade' : falta + ' unidades';
          return { ok: false, motivo: 'quantidade', falta: falta,
            texto: jaLa > 0
              ? 'Só dá para juntar mais ' + un + ', porque o resto já está no carrinho.'
              : 'Só rest' + (falta === 1 ? 'a ' : 'am ') + un + ' em stock.' };
        }
        return { ok: true };
      });
    }).catch(function () { return { ok: true }; });
  };

  // ------------------------------------------------------------- 4. as quantidades do carrinho
  // O `max` de cada linha vem do `snippets/proa-max-carrinho.liquid` (o stock). O «+» respeita-o,
  // mas um número ESCRITO à mão ia tal e qual para `/cart/change` e dava 422 (auditoria de 03/10).
  // Corta-se ao máximo ANTES do tema: este `change` ouve-se na captura, que corre primeiro.
  var SELETOR_QTD = 'cart-items input[max], cart-drawer input[max], #CartDrawer input[max], .cart-item input[max]';
  function acertarMais(input) {
    var caixa = input.closest('quantity-input') || input.parentElement;
    var mais = caixa && caixa.querySelector('button[name="plus"]');
    // ⛔ 04/10/2026 (achado da Maré): uma linha de BRINDE é trancada por ELES
    // (`data-mare-trancado`). Um brinde de 1 unidade com stock de 5 dava `1 >= 5` falso e eu
    // RELIGAVA o «+»: a cliente levava dois brindes e pagava o segundo. Quem tranca é que destranca.
    if (mais && mais.hasAttribute('data-mare-trancado')) return;
    var max = parseInt(input.getAttribute('max'), 10);
    if (mais && max >= 0) mais.toggleAttribute('disabled', (parseInt(input.value, 10) || 0) >= max);
  }
  document.addEventListener('change', function (ev) {
    var i = ev.target;
    if (!i || !i.matches || !i.matches(SELETOR_QTD)) return;
    var max = parseInt(i.getAttribute('max'), 10);
    var v = parseInt(i.value, 10);
    if (max >= 0 && v > max) i.value = String(max);
    acertarMais(i);
  }, true);
  function acertarTodos(raiz) {
    var ins = (raiz || document).querySelectorAll(SELETOR_QTD);
    for (var k = 0; k < ins.length; k++) acertarMais(ins[k]);
  }
  // ⚠️ O carrinho do tema redesenha-se em vários tempos (a secção, e depois os <template> das linhas):
  // medido a 03/10, o «+» ficava ligado no máximo. Confere-se outra vez já assentado.
  var aAcertar = null;
  function acertarDepois() {
    clearTimeout(aAcertar);
    aAcertar = setTimeout(function () { acertarTodos(document); setTimeout(function () { acertarTodos(document); }, 600); }, 150);
  }

  // ⚠️ Outro script volta a LIGAR o «+»: a extensão da Maré (`mare-guarda.js`) põe `disabled = false`
  // em todas as linhas que não são brinde, a cada mudança do carrinho (medido a 03/10). Por isso
  // vigia-se o próprio atributo: ligado numa linha que já está no máximo, volta a desligar-se.
  function vigiarMais() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var b = ms[i].target;
        if (!b || b.disabled || b.getAttribute('name') !== 'plus') continue;
        if (b.hasAttribute('data-mare-trancado')) continue;  // a linha de brinde é da Maré
        var caixa = b.closest('quantity-input') || b.parentElement;
        var inp = caixa && caixa.querySelector('input[max]');
        if (inp && inp.matches(SELETOR_QTD)) acertarMais(inp);
      }
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }

  // ------------------------------------------------------------- arranque
  function arrancar() {
    procurar(document);
    acertarTodos(document);
    vigiarMais();
    // montras desenhadas depois (o «visto», as gavetas, a vista rápida)
    if ('MutationObserver' in window) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          for (var j = 0; j < ms[i].addedNodes.length; j++) {
            var n = ms[i].addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches(SELETOR)) vigiar(n);
            else if (n.querySelectorAll) { procurar(n); if (n.querySelector && n.querySelector('input[max]')) acertarDepois(); }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
